"use client";

import { MODALS, PAGES } from "@idss/libraries";
import { handleError, handleSuccess } from "@idss/notification";
import { Button, PasswordInput, Stack } from "@mantine/core";
import { Form, useForm, yupResolver } from "@mantine/form";
import { modals } from "@mantine/modals";
import { useMutation } from "@tanstack/react-query";
import { object, ref, string } from "yup";

import { navigate } from "@/actions/navigate";
import { builder } from "@/builders";

const schema = object({
  password: string().required("Old password is required"),
  new_password: string().required("Password is required"),
  confirm_password: string()
    .oneOf([ref("new_password")], "Passwords must match")
    .required("Password is required"),
});

export function ChangePassword() {
  const form = useForm({
    initialValues: {
      password: "",
      new_password: "",
      confirm_password: "",
    },
    validate: yupResolver(schema),
    validateInputOnBlur: true,
  });

  const { mutate, isPending } = useMutation({
    mutationFn: builder.$use.account.change_password,
    onSuccess: ({ message }) => {
      handleSuccess({
        message,
      });

      modals.close(MODALS.CHANGE_PASSWORD);
      navigate(PAGES.LOGOUT);
    },
    onError: handleError(),
  });

  function handleSubmit(value: typeof form.values) {
    mutate({ password: value.password, new_password: value.new_password });
  }

  return (
    <Form form={form} onSubmit={handleSubmit}>
      <Stack gap={24}>
        <PasswordInput
          label="Old password"
          placeholder="******************"
          type="password"
          {...form.getInputProps("password")}
        />
        <PasswordInput
          label="New password"
          placeholder="******************"
          type="password"
          {...form.getInputProps("new_password")}
        />
        <PasswordInput
          label="Confirm password"
          placeholder="******************"
          type="password"
          {...form.getInputProps("confirm_password")}
        />
        <Button type="submit" loading={isPending} disabled={isPending}>
          Save new password
        </Button>
      </Stack>
    </Form>
  );
}
